/**
 * 타로카드 의미 데이터
 * 각 콘텐츠에서 공용으로 사용할 수 있는 카드 정보
 */

export const TAROT_CARDS = {
  0: {
    cardName: "THE FOOL (바보)",
    description: "새로운 시작과 무한한 가능성을 상징하는 THE FOOL 카드는 여행을 떠나는 순수한 영혼을 나타내요. 이 카드는 어린 아이와 같은 순수함과 호기심, 그리고 미지의 세계로 향하는 용기를 상징해요. 바보라는 이름이지만 실제로는 가장 지혜로운 존재를 의미하기도 해요. 왜냐하면 기존의 고정관념이나 편견에 얽매이지 않고 자유롭게 세상을 바라볼 수 있는 능력을 가지고 있기 때문이에요. 이 카드가 나타날 때는 새로운 모험이 시작되는 시점이며, 과거의 경험이나 실패에 대한 두려움을 버리고 순수한 마음으로 앞으로 나아가야 할 때예요. 절벽 끝에 서 있는 모습은 위험해 보일 수 있지만, 실제로는 신뢰와 용기를 바탕으로 한 도약을 의미해요.",
    keywords: ["새로운 시작", "순수함", "모험", "가능성", "용기"]
  },
  1: {
    cardName: "THE MAGICIAN (마법사)",
    description: "THE MAGICIAN 카드는 의지력과 창조력, 그리고 강력한 실행능력을 상징하는 가장 역동적인 카드 중 하나예요. 이 카드 속의 마법사는 하늘을 가리키는 한 손과 땅을 가리키는 다른 한 손으로 천지의 에너지를 연결하는 역할을 해요. 테이블 위에 놓인 네 가지 원소(검, 컵, 펜타클, 완드)는 마법사가 모든 영역에서 능력을 발휘할 수 있음을 나타내요. 무한대 기호는 끝없는 가능성과 순환하는 에너지를 의미하며, 머리 위의 꽃은 영적 성장과 깨달음을 상징해요. 이 카드가 나타날 때는 단순히 꿈꾸기만 하는 것이 아니라 실제로 현실에서 그 꿈을 구현할 수 있는 능력과 기회가 주어진다는 뜻이에요. 마법사는 모든 도구와 자원을 활용해 원하는 것을 창조해내는 능력의 화신이에요.",
    keywords: ["의지력", "창조력", "실행력", "능력", "성취"]
  },
  2: {
    cardName: "THE HIGH PRIESTESS (여사제)",
    description: "THE HIGH PRIESTESS는 직감과 내면의 지혜, 그리고 신비로운 통찰력을 상징하는 깊이 있는 카드예요. 두 기둥 사이에 앉아 있는 여사제는 의식과 무의식, 현실과 영적 세계 사이의 경계에서 중재자 역할을 해요. 뒤에 걸린 석류 무늬 커튼은 숨겨진 지식과 비밀을 나타내며, 발밑의 초승달은 여성적 직감과 순환하는 시간을 의미해요. 손에 든 토라 두루마리에는 'TORA'라고 쓰여 있는데, 이는 신성한 법칙과 우주의 지혜를 상징해요. 이 카드는 외부의 소음이나 급한 판단보다는 내면 깊숙한 곳에서 울려 퍼지는 직감의 목소리에 귀 기울여야 할 때를 알려줘요. 여사제는 수동적으로 보일 수 있지만, 실제로는 가장 강력한 내적 힘을 가지고 있으며, 침묵 속에서 진실을 파악하고 미래를 내다보는 능력을 지니고 있어요.",
    keywords: ["직감", "내면의 지혜", "통찰력", "비밀", "신비"]
  },
  3: {
    cardName: "THE EMPRESS (여황제)",
    description: "THE EMPRESS는 풍요로움과 창조성, 그리고 따뜻한 모성애를 상징하는 대지의 어머니 같은 카드예요. 수정으로 만들어진 왕관에는 12개의 별이 있어 조디악과 자연의 순환을 나타내며, 하얀 드레스는 생명력과 풍요를 상징해요. 주변의 울창한 자연과 풍성한 배경은 어머니 대지의 풍요로움을 자아내요. 귀에 착용한 진주 귀걸이는 귀중한 것에 대한 감상력과 아름다움에 대한 사랑을 나타내죠. 여황제의 발아래에는 비너스 심볼이 있어 여성적 에너지와 사랑의 힘을 상징해요. 이 카드는 단순히 물질적 풍요로움만을 의미하는 것이 아니라, 정서적 풍요로움과 창조적 에너지를 나타내며, 사랑과 보살핌으로 주변 세계를 아름답게 변화시키는 능력을 의미해요.",
    keywords: ["풍요", "창조성", "모성애", "번영", "사랑"]
  },
  4: {
    cardName: "THE EMPEROR (황제)",
    description: "THE EMPEROR는 권위와 안정성, 그리고 확고한 의지력을 상징하는 강력한 리더십의 카드예요. 빨간색 옷은 열정과 활력, 그리고 행동하는 에너지를 나타내며, 든든한 돌 왕좌는 오랜 경험과 지혜로 쌓아 올린 권위를 상징해요. 왼손에 든 글로부스(세상의 구)는 세상에 대한 통제력과 영향력을 나타내며, 오른손에 든 방망이는 남성적 에너지와 직선적인 사고방식을 상징해요. 보좌의 양의 머리는 남성적 강인함과 담대함을 나타내죠. 배경에 보이는 거대한 바위 산맥은 황제가 신념과 원칙을 기반으로 단단한 기반을 구축했음을 의미해요.",
    keywords: ["권위", "안정성", "의지력", "리더십", "질서"]
  },
  5: {
    cardName: "THE HIEROPHANT (교황)",
    description: "THE HIEROPHANT는 전통과 영적 지혜, 그리고 신성한 가르침을 상징하는 신성한 지도자의 카드예요. 교황의 머리에 쓴 삼중관은 세속적 권력을 넘어선 영적 권위를 나타내며, 오른손에 든 세 갈래의 십자가는 성직자의 직위를 상징해요. 의복에 그린 아름다운 도안은 영적 깨달음과 고귀한 지식을 나타내며, 발치에서 납작히 엎드리고 있는 두 제자들은 선생과 제자 간의 전통적인 지식 전수 과정을 보여주죠. 이 카드는 단순히 경직되고 보수적인 가치만을 의미하는 것이 아니라, 조상들의 지혜와 전통에서 배울 점을 찾고, 그것을 현대적으로 재해석하여 자신만의 영적 성장과 깨달음을 이룰 수 있는 능력을 의미해요.",
    keywords: ["전통", "영적 지혜", "가르침", "깨달음", "종교"]
  },
  6: {
    cardName: "THE LOVERS (연인)",
    description: "사랑과 조화, 중요한 선택을 상징하는 카드입니다. 이 카드는 단순한 로맨틱한 사랑만을 의미하지 않아요. 인생에서 마주하는 중대한 선택의 순간, 가치관의 일치, 그리고 내면과 외면의 조화를 모두 포함하고 있답니다. 두 존재가 하나로 어우러지는 깊은 유대감과 마음의 합일을 통해 진정한 행복을 찾을 수 있는 시기를 나타내요. 또한 이 카드는 자신의 진정한 가치를 알아봐주는 사람과의 만남, 또는 스스로의 가치를 인정하는 자기 수용의 과정을 상징하기도 해요.",
    keywords: ["사랑", "조화", "선택", "유대감", "가치관"]
  },
  7: {
    cardName: "THE CHARIOT (전차)",
    description: "의지력과 승리, 목표 달성을 상징하는 카드입니다. 전차 카드는 강한 결의와 집중력으로 어떤 장애물도 극복하고 최종 승리를 거머쥘 수 있는 시기를 나타내요. 두 마리의 말(또는 스핑크스)이 서로 다른 방향으로 가려는 것을 능숙하게 제어하는 전차의 기수처럼, 상반된 힘들을 조화롭게 다스려 앞으로 나아가는 지혜를 상징해요. 이 카드는 단순한 물리적 힘이 아닌, 정신적 의지력과 자기 통제력의 중요성을 강조합니다.",
    keywords: ["의지력", "승리", "목표달성", "집중력", "통제력"]
  },
  8: {
    cardName: "STRENGTH (힘)",
    description: "내면의 힘과 용기, 인내력을 상징하는 카드입니다. 힘 카드에서 보여주는 것은 물리적인 힘이 아닌, 부드러움으로 거친 것을 다스리는 진정한 강함이에요. 사자의 입을 부드럽게 쓰다듬는 여인의 모습처럼, 공포나 분노와 같은 원초적인 감정을 억압하지 않고 자연스럽게 품어 다스리는 지혜를 나타내요. 이 카드는 어려운 상황에서도 평정심을 유지하고, 인내와 끈기로 문제를 해결해나가는 능력을 상징합니다.",
    keywords: ["내면의 힘", "용기", "인내력", "평정심", "자제력"]
  },
  9: {
    cardName: "THE HERMIT (은둔자)",
    description: "내면 탐구와 성찰, 지혜 탐구를 상징하는 카드입니다. 은둔자 카드는 혼자만의 시간을 통해 삶의 진실을 발견하고 깊은 깨달음을 얻을 수 있는 시기를 나타내요. 산 정상에서 등불을 들고 서 있는 은둔자의 모습은, 세상의 소음에서 벗어나 내면의 빛을 따라가는 지혜로운 존재를 상징해요. 이 카드는 외부에서 답을 찾기보다 자신의 내면으로 여행을 떠나야 할 때를 알려줍니다.",
    keywords: ["내면탐구", "성찰", "지혜", "고독", "깨달음"]
  },
  10: {
    cardName: "WHEEL OF FORTUNE (운명의 수레바퀴)",
    description: "운명의 변화와 새로운 기회, 행운의 순환을 상징하는 카드입니다. 운명의 수레바퀴 카드는 인생의 끊임없는 변화와 순환, 그리고 그 속에서 찾아오는 행운과 기회를 나타내요. 수레바퀴가 돌듯이 인생도 끊임없이 변화해요. 좋은 때가 있으면 어려운 때도 있고, 어려운 때가 있으면 다시 좋은 때가 찾아오죠. 이 카드는 우주의 섭리와 운명의 흐름에 순응하면서도, 주어진 기회를 놓치지 않는 지혜를 상징합니다.",
    keywords: ["운명", "변화", "순환", "기회", "행운"]
  },
  11: {
    cardName: "JUSTICE (정의)",
    description: "공정함과 균형, 올바른 판단을 상징하는 카드입니다. 정의 카드는 저울과 칼을 들고 있는 정의의 여신의 모습으로, 진실을 추구하고 공정한 판단을 내리는 것의 중요성을 나타내요. 이 카드는 모든 행동에는 결과가 따른다는 인과의 법칙을 상기시켜줍니다. 올바른 일을 하면 좋은 결과가, 그렇지 않으면 그에 상응하는 결과가 따라온다는 것이죠.",
    keywords: ["공정함", "균형", "정의", "판단", "진실"]
  },
  12: {
    cardName: "THE HANGED MAN (매달린 사람)",
    description: "희생과 관점의 전환, 내려놓음을 상징하는 카드입니다. 매달린 사람 카드는 거꾸로 매달려 있지만 평온한 표정을 짓고 있는 인물의 모습으로, 기존의 관점을 완전히 뒤집어 새로운 시각으로 세상을 바라볼 것을 권유해요. 이 카드는 때로는 멈춤과 기다림이 전진보다 더 큰 지혜임을 알려줍니다.",
    keywords: ["희생", "관점전환", "내려놓음", "기다림", "통찰"]
  },
  13: {
    cardName: "DEATH (죽음)",
    description: "끝과 새로운 시작, 변화와 재생을 상징하는 카드입니다. 죽음 카드는 언뜻 무섭게 느껴질 수 있지만, 실제로는 물리적인 죽음이 아닌 변화와 변형, 그리고 재탄생을 의미해요. 오래된 것이 끝나야 새로운 것이 시작될 수 있다는 자연의 순환 법칙을 담고 있죠. 이 카드는 더 이상 필요하지 않은 것들을 과감히 떠나보내고 새로운 시작을 위한 공간을 마련할 때임을 알려줍니다.",
    keywords: ["변화", "재생", "끝과 시작", "변형", "해방"]
  },
  14: {
    cardName: "TEMPERANCE (절제)",
    description: "조화와 균형, 중용의 지혜를 상징하는 카드입니다. 절제 카드는 두 잔 사이에서 물을 조화롭게 섞고 있는 천사의 모습으로, 극단을 피하고 균형 잡힌 삶을 통해 안정과 평화를 찾을 수 있는 시기를 나타내요. 이 카드는 인내심을 가지고 천천히, 그러나 꾸준히 목표를 향해 나아가는 것의 중요성을 강조합니다.",
    keywords: ["조화", "균형", "절제", "인내", "안정"]
  },
  15: {
    cardName: "THE DEVIL (악마)",
    description: "유혹과 속박, 물질적 집착을 상징하는 카드입니다. 악마 카드는 언뜻 부정적으로 보일 수 있지만, 실제로는 자신을 제한하고 있는 것들을 인식하고 진정한 자유를 찾아야 할 때임을 알려주는 중요한 카드예요. 이 카드에서 사슬에 묶여 있는 두 인물은 사실 스스로 사슬을 벗을 수 있지만, 그것을 인식하지 못하고 있죠.",
    keywords: ["유혹", "속박", "집착", "자유", "해방"]
  },
  16: {
    cardName: "THE TOWER (탑)",
    description: "갑작스러운 변화와 깨달음, 기존 구조의 붕괴를 상징하는 카드입니다. 탑 카드는 번개에 맞아 무너지는 탑의 모습으로, 예상치 못한 격변과 기존에 쌓아올린 것들의 붕괴를 나타내요. 처음에는 충격적이고 파괴적으로 느껴질 수 있지만, 이 카드는 실제로 잘못된 기반 위에 세워진 것들이 무너지고 더 견고한 새로운 시작을 위한 기회를 제공해요.",
    keywords: ["갑작스러운 변화", "깨달음", "붕괴", "해방", "새시작"]
  },
  17: {
    cardName: "THE STAR (별)",
    description: "희망과 영감, 치유와 재생을 상징하는 카드입니다. 별 카드는 밤하늘에 빛나는 별빛 아래서 물을 붓고 있는 인물의 모습으로, 어둠 속에서도 희망의 빛을 발견하고 꿈을 향해 나아갈 수 있는 시기를 나타내요. 폭풍(탑 카드)이 지나간 후 찾아오는 고요하고 평화로운 밤처럼, 이 카드는 어려운 시기를 지나 회복과 재생의 시간이 왔음을 알려줍니다.",
    keywords: ["희망", "영감", "치유", "재생", "평화"]
  },
  18: {
    cardName: "THE MOON (달)",
    description: "직감과 무의식, 숨겨진 진실을 상징하는 카드입니다. 달 카드는 어둠 속에서 비추는 달빛의 모습으로, 표면적으로 드러나지 않은 것들을 직감으로 파악하고 내면의 목소리에 귀 기울여야 할 시기를 나타내요. 달빛은 태양빛과 달리 사물을 완전히 밝히지 않고 그림자와 신비를 만들어내죠. 이처럼 이 카드는 불확실성, 환상과 현실 사이의 경계, 숨겨진 감정과 두려움을 상징합니다.",
    keywords: ["직감", "무의식", "신비", "환상", "두려움"]
  },
  19: {
    cardName: "THE SUN (태양)",
    description: "기쁨과 성공, 활력과 긍정적 에너지를 상징하는 카드입니다. 태양 카드는 밝게 빛나는 태양과 그 아래서 즐겁게 노는 아이의 모습으로, 순수한 기쁨, 생명력, 성공과 번영을 나타내요. 타로 덱에서 가장 긍정적인 카드 중 하나로, 이 카드가 나타났다면 밝은 에너지와 행복으로 가득 찬 시기가 다가오고 있음을 의미해요.",
    keywords: ["기쁨", "성공", "활력", "긍정", "번영"]
  },
  20: {
    cardName: "JUDGEMENT (심판)",
    description: "각성과 재생, 새로운 깨달음을 상징하는 카드입니다. 심판 카드는 천사가 나팔을 불고 그 소리에 사람들이 깨어나는 모습으로, 중요한 각성의 순간과 새로운 차원으로의 도약을 나타내요. 이 카드는 과거를 돌아보고 평가하여 더 높은 차원의 성장을 이룰 수 있는 시기가 왔음을 알려줍니다.",
    keywords: ["각성", "재생", "깨달음", "평가", "성장"]
  },
  21: {
    cardName: "THE WORLD (세계)",
    description: "완성과 성취, 조화로운 통합을 상징하는 카드입니다. 세계 카드는 월계수 화관 안에서 춤추는 인물의 모습으로, 모든 것이 완성되고 성취감과 만족감을 느낄 수 있는 최고의 시기를 나타내요. 메이저 아르카나의 마지막 카드로서, 하나의 중요한 여정이 성공적으로 마무리되었음을 축하하는 카드랍니다.",
    keywords: ["완성", "성취", "통합", "조화", "만족"]
  }
};

/**
 * 카드 번호로 카드 정보를 가져오는 함수
 * @param {number} cardNumber - 카드 번호 (0-21)
 * @returns {object} 카드 정보
 */
export const getCardInfo = (cardNumber) => {
  return TAROT_CARDS[cardNumber] || null;
};

/**
 * 카드 이름을 가져오는 함수
 * @param {number} cardNumber - 카드 번호 (0-21)
 * @returns {string} 카드 이름
 */
export const getCardName = (cardNumber) => {
  const card = TAROT_CARDS[cardNumber];
  return card ? card.cardName : null;
};

/**
 * 카드 설명을 가져오는 함수
 * @param {number} cardNumber - 카드 번호 (0-21)
 * @returns {string} 카드 설명
 */
export const getCardDescription = (cardNumber) => {
  const card = TAROT_CARDS[cardNumber];
  return card ? card.description : null;
};

/**
 * 카드 키워드를 가져오는 함수
 * @param {number} cardNumber - 카드 번호 (0-21)
 * @returns {array} 카드 키워드 배열
 */
export const getCardKeywords = (cardNumber) => {
  const card = TAROT_CARDS[cardNumber];
  return card ? card.keywords : [];
};